import React, { useEffect } from 'react';
import { login } from 'services/auth';

export default function Login() {
  useEffect(() => {
    login();
  }, []);

  return <div />;
}
